import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { type FocusVisibleProps, focusVisibleOutline } from 'components/FocusVisible'

export const Button = styled(ButtonPlain)<FocusVisibleProps>`
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;

	pointer-events: auto;

	${focusVisibleOutline}

	border-radius: 10px;
	outline-offset: -6px;
`
